import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";

import RTMeters from "components/RTMeters/Meters/RTMeters";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import { Redirect, useLocation } from "react-router-dom";
import RTDashboard from "components/RTMeters/Dashboard/RTDashboard";
import RTMetersTab from "components/RTMeters/RTMetersTab";
import postPageVisit from "services/LogService";

export default function Meters() {
  // console.log("Page plan d'actions");
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const [selectedTab, setSelectedTab] = useState('');

  useEffect(() => {
    let selected = '0';
    if (params && params.get("tab") === 'dashboard') {
      selected = '1';
    }
    else
      selected = '0';

    setSelectedTab(selected);
    setPage('meters');
    postPageVisit('meters');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/meters",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"meters"}
    >
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <Card>
            <CardBody>
              <RTMetersTab  meters={<RTMeters />} dashboard={<RTDashboard />} selectedTab={selectedTab}/>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
